<template>
    <div class="outer">
        <div class="inner">
            <slot />
        </div>
    </div>
</template>

<style scoped lang="scss">
.outer {
    padding-left: 1rem;
    padding-right: 1rem;
}

.inner {
    max-width: 1080px;
    margin: 0 auto;
}

@media (min-width: $breakpoint-tablet) {
    .outer {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
}
</style>
